import { jsx as _jsx } from "react/jsx-runtime";
import { Check as CheckIcon } from "@air/next-icons";
import { memo, useMemo } from "react";
import { DropdownMenu } from "./DropdownMenu";
import { renderDropdownItems } from "./utils/renderDropdownItems";
export const SelectDropdownMenu = /*#__PURE__*/ memo((param)=>{
    let { onSelect, options, selectedOption, size, trigger, ...restOfProps } = param;
    const optionsWithSelect = useMemo(()=>options === null || options === void 0 ? void 0 : options.map((option)=>{
            if (option.type === "item") {
                const isOptionSelected = option.id === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.id);
                return {
                    ...option,
                    onSelect: ()=>{
                        var _option_onSelect;
                        option === null || option === void 0 ? void 0 : (_option_onSelect = option.onSelect) === null || _option_onSelect === void 0 ? void 0 : _option_onSelect.call(option);
                        if (option.canSelect) {
                            onSelect === null || onSelect === void 0 ? void 0 : onSelect(option);
                        }
                    },
                    suffix: isOptionSelected ? /*#__PURE__*/ _jsx(CheckIcon, {
                        className: "size-4 fill-blue-9"
                    }) : option.suffix
                };
            }
            return option;
        }), [
        onSelect,
        options,
        selectedOption
    ]);
    return /*#__PURE__*/ _jsx(DropdownMenu, {
        size: size,
        trigger: typeof trigger === "function" ? trigger(selectedOption) : trigger,
        ...restOfProps,
        children: renderDropdownItems({
            options: optionsWithSelect,
            size
        })
    });
});
SelectDropdownMenu.displayName = "SelectDropdownMenu";
